"use strict";
angular.module("selectiveOrganizationModule", []).
controller("selectiveOrganizationCtrl", ["$scope", "$modalInstance", "groups",
    function($scope, $modalInstance, groups) {
        initStatus();

        function initStatus() {
            $scope.data = {
                selectedGroup: groups[0].tenantId,
                groups: groups
            }
        }
        $scope.confirm = function() {
            $modalInstance.close($scope.data.selectedGroup);
        };
    }
]);